/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    HasClaimsLabel: {
        id: 'spm.components.claimDetails.HasClaimsLabel',
        defaultMessage: 'Have {pronoun} had, regardless of fault, any claims, accidents or incidents in the last 5 years?'
    },
    ClaimTypeLabel: {
        id: 'spm.components.claimDetails.ClaimTypeLabel',
        defaultMessage: 'Please select the closest description:'
    },
    ClaimTypeLabelAggs: {
        id: 'spm.components.claimDetails.ClaimTypeLabelAggs',
        defaultMessage: '{possessivePronoun} claim description:'
    },
    ClaimFaultLabel: {
        id: 'spm.components.claimDetails.ClaimFaultLabel',
        defaultMessage: 'Was this a fault claim?'
    },
    ClaimFaultLabelAggsText: {
        id: 'spm.components.claimDetails.ClaimFaultLabelAggsText',
        defaultMessage: 'Fault status'
    },
    ClaimDateLabel: {
        id: 'spm.components.claimDetails.ClaimDateLabel',
        defaultMessage: 'Please enter the date of the incident:'
    },
    ClaimDateLabelAggs: {
        id: 'spm.components.claimDetails.ClaimDateLabelAggs',
        defaultMessage: '{possessivePronoun} claim date'
    },
    SaveClaimButtonText: {
        id: 'spm.components.claimDetails.SaveClaimButtonText',
        defaultMessage: 'Save claim'
    },
    AddNewClaimButtonLabel: {
        id: 'spm.components.claimDetails.AddNewClaimButtonLabel',
        defaultMessage: 'Add another claim'
    },
    Cancel: {
        id: 'spm.components.claimDetails.Cancel',
        defaultMessage: 'Cancel'
    },
    CommonClaims: {
        id: 'spm.components.claimDetails.CommonClaims',
        defaultMessage: '---- Common claims ----'
    },
    AllClaims: {
        id: 'spm.components.claimDetails.AllClaims',
        defaultMessage: '---- All claims ----'
    },
    PleaseSelect: {
        id: 'spm.components.claimDetails.pleaseSelect',
        defaultMessage: 'Please select...'
    },
    FaultHelpQuestion: {
        id: 'spm.components.claimDetails.FaultHelpQuestion',
        defaultMessage: 'What\'s a fault claim?'
    },
    FaultHelpAnswer: {
        id: 'spm.components.claimDetails.FaultHelpAnswer',
        defaultMessage: 'Although it sounds like it is assigning blame, a fault claim just means that your insurer has to pay the claim costs and can\'t claim them back from the other person\'s insurer. This includes situations where your insurer has had to share costs with another party\'s insurer.'
    },
    NotFaultHelpQuestion: {
        id: 'spm.components.claimDetails.NotFaultHelpQuestion',
        defaultMessage: 'What\'s a non-fault claim?'
    },
    NotFaultHelpAnswer: {
        id: 'spm.components.claimDetails.NotFaultHelpAnswer',
        defaultMessage: 'A non-fault claim isn\'t about blame, it just means that your insurer can claim back the costs from the other person\'s insurer.'
    },
    UpdateNeededMessage: {
        id: 'spm.components.claimDetails.UpdateNeededMessage',
        defaultMessage: 'Due to changes we have made, we need some additional information to calculate your premium. Please re-enter the details of your claim(s) and select the closest description and fault status of your claim below:'
    }
});
